import phoneNumber from './phoneNumber';
import onlyPersianLetter from './onlyPersianLatter';
import onlyNumber from './onlyNumber';
import onlyNumberMath from './onlyNumberMath';
import onlyPersianWithNumberLatter from './onlyPersianWithNumberLatter';

const regex = {
  phoneNumber,
  onlyPersianLetter,
  onlyNumber,
  onlyNumberMath,
  onlyPersianWithNumberLatter
};

export default regex;
